<script lang="ts">
import useValidate from '@vuelidate/core'
import i3pSubComponent from '../I3pSubComponent.vue'
import { I3pEventsEnum } from '../../../types/I3pEvents.enum'
import type { BaseModel } from '../../../models/BaseModel'
import type { IndexResponse } from '../../../types/Api/Response/IndexResponse'

// noinspection JSUnusedGlobalSymbols
export default {
    name: 'EntityPanel',
    extends: i3pSubComponent,
    props: {
    },
    data() {
        return {
            dataIsEmpty: false,
            entity: null,
            nextKey: null,
            previousKey: null,
            v$: useValidate(),
        }
    },
    mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.currentEntityUpdated, (event: { currentEntity: BaseModel<any> | null }) => {
                this.entity = event.currentEntity
                if (this.entity?.data?.k) {
                    this.routerPushEntity(this.entity.data.k)
                    this.updatePreviousNext()
                    this.getCurrentEntityGeometry()
                }
                else {
                    this.routerPushEntity(null)
                }
            })

        this.i3pService.emitter
            .on(I3pEventsEnum.entityDeleted, () => {
                this.showEntity(this.i3pService.indexPositionData[0] || this.nextKey || this.previousKey) // ROUTE AUTO REFRESH ON currentEntityUpdated
            })

        this.i3pService.emitter
            .on(I3pEventsEnum.indexDataUpdated, (res: { indexData: IndexResponse<any> }) => {
                this.dataIsEmpty = !res.indexData.data?.length
            })

        this.i3pService.emitter
            .on(I3pEventsEnum.allDataUpdated, () => {
                if (!this.entity) // UPDATE ROUTE OR ENTITY WHEN LOADING POSITION
                    this.checkEntityKRoute(this.$route.params?.k ?? null)

                this.updatePreviousNext()
            })

        this.i3pService.emitter
            .on(I3pEventsEnum.beforeSaveEntity, () => {
                this.saveEntity()
            })

        // TODO mettre a jour le prev et next avant d'avoir recupere la donnée complete
        // this.i3pService.emitter
        //     .on(I3pEventsEnum.currentEntityUpdating, (event: {currentEntityK: string|number}) => {
        //         this.updatePreviousNext(event.currentEntityK) // permettre d'updatePreviousNext avec un parametre k
        //     })
    },
    methods: {
        // INITIALIZE GEOMETRY WHEN RULE EXIST TO PREVENT geometry = null
        getCurrentEntityGeometry() {
            if (this.entity) {
                this.updateData({ geometry: this.i3pService.getCurrentEntityGeometry() })
            }
        },
        updateData(toUpdate: object) {
            if (toUpdate) {
                const keys = Object.keys(toUpdate)
                keys.forEach((key) => {
                    const pathArray = key.split('.')
                    const lastNode = pathArray[pathArray.length - 1]

                    let node = this.entity.data
                    pathArray.forEach((path, index) => node = index === pathArray.length - 1 ? node : node[path])
                    node[lastNode] = toUpdate[key]
                })
            }
        },
        showEntity(k) {
            this.i3pService.showEntity(k).then()
        },
        setEditMode(value: boolean) {
            this.i3pService.setEditMode(value)
        },
        updatePreviousNext() {
            this.nextKey = this.i3pService.getNextKey()
            this.previousKey = this.i3pService.getPreviousKey()
        },
        checkEntityKRoute(k: string | null = null) {
            if (k === this.i3pService.creationSlug) {
                this.i3pService.createEntity().then(() => {
                    this.i3pService.setEditMode(true)
                })
                return
            }
            if (this.$route.params.k) {
                this.showEntity(this.$route.params.k)
                return
            }
            if (k) {
                this.routerPushEntity(k)
                this.showEntity(k)
            }
            else {
                this.i3pService.loadFirstItem()
            }
        },
        deleteEntity() {
            const nextKey = this.i3pService.getNextKey() // get next key before deleting
            this.i3pService.deleteEntity(this.entity).then(() => {
                const previousKey = this.i3pService.getPreviousKey()
                if (previousKey || nextKey) {
                    this.showEntity()
                }
            })
        },

        saveEntity() {
            this.v$.$touch()
            this.v$.$validate()

            setTimeout(async () => {
                if (this.v$.$error) {
                    // this.saving = false

                    let msg = `Veuillez renseigner les champs obligatoires.`
                    console.warn('validation fail', this.v$.$errors)

                    if (this.v$.$errors.filter(e => e.$uid === 'entity.data.geometry-required').length > 0) {
                        msg += `<br>Veuillez saisir une géométrie valide.`
                    }

                    this.$showToaster({
                        text: msg,
                        color: 'warning',
                        icon: 'mdi-alert-circle',
                    })
                }
                else {
                    if (this.entity.data.k) {
                        this.i3pService.updateEntity(this.entity).then(() => {
                            this.i3pService.showEntity(this.entity.data.k).then(() => {
                                this.setEditMode(false)
                            })
                        })
                    }
                    else {
                        this.i3pService.storeEntity(this.entity).then((entity) => {
                            this.i3pService.showEntity(entity.data.k).then(() => {
                                this.setEditMode(false)
                            })
                        })
                    }
                }
            })
        },
        routerPushEntity(k: string | null) {
            console.warn('EntityPanel routerPushEntity() must be set by entity')
            if (k) {
                this.$router.push(`/CHANGEME/${k}`)
                return
            }
            this.$router.push(`/CHANGEME/${this.i3pService.creationSlug}`)
        },
    },
    validations() {
        return {
            entity: {
                ...this.entity?.getVuelidations(),
            },
        }
    },
}
</script>

<template>
    Panel
    <pre v-if="previousKey" @click="showEntity(previousKey)">previous: {{ previousKey }}</pre>
    <pre v-if="nextKey" @click="showEntity(nextKey)">next: {{ nextKey }}</pre>
    <pre>{{ entity }}</pre>
</template>
